import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'PriceTable',
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      isPremium: false,
      selectedCategory: null,
      selectedProduct: 1,
      options: {
        arrows: true,
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 1740,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    }
  },
  mounted() {
    if (window.location.hash) {
      var urlHash = window.location.hash.substring(1)
      this.selectedCategory = urlHash.split('_')[0]
      this.selectedProduct = urlHash.split('_')[1]

      let productIndex = 0;
      if (this.selectedProduct != undefined) {
        var productElm = document.querySelector(
          `#${this.selectedCategory} ~ .price-table__accordion-content .price-table__product-list #${this.selectedProduct}`
        )

        productIndex = Array.from(productElm.parentNode.children).indexOf(productElm)
      }

      this.$nextTick(() => {
        document
          .querySelector(`#${this.selectedCategory}`)
          .scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })

        this.setSelectedProduct(productIndex + 1)
      })
    }

    // To-Do: Refractor to a new component maybe
    document.querySelectorAll('[data-max-selected]').forEach(this.handleMaxCheckbox)
  },
  methods: {
    setSelectedCategory(cat) {
      this.selectedCategory = cat
      this.selectedProduct = 1
      this.isPremium = false

      this.$nextTick(function () {
        document
          .querySelector(`#${cat}`)
          .scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
      })
    },

    setSelectedProduct(prod) {
      this.selectedProduct = prod
      this.isPremium = false
    },

    togglePremium() {
      this.isPremium = !this.isPremium
    },

    handleMaxCheckbox(wrapper) {
      let chkboxs = wrapper.querySelectorAll('[type="checkbox"]')
      let maxAllowed = parseInt(wrapper.dataset.maxSelected)

      function checkMaxSelected() {
        return [...chkboxs].filter(input => input.checked).length
      }

      function toggleDisabledCheckboxes(disabled) {
        chkboxs.forEach(chkbox => (!chkbox.checked ? (chkbox.disabled = disabled) : false))
      }

      chkboxs.forEach(chkbox => {
        chkbox.addEventListener('change', ev => {
          toggleDisabledCheckboxes(checkMaxSelected() >= maxAllowed)
        })
      })
    },

    sendEmail(event, category, product, col, productIndex) {
      event.preventDefault()

      const optionSelector = `${category}-${product}-${col}-${productIndex}${
        this.isPremium ? '-premium' : ''
      }`

      const options = document.querySelectorAll(
        `[data-product-index="${optionSelector}"] [type="checkbox"]:checked`
      )

      const selectedOptions = [...options]
        .map(option => `*%20${option.name}%0D%0A`)
        .toString()
        .replace(',', '')

      const txt = this.getEmailText(this.$store.state.lang, category, product, col, selectedOptions)

      window.location.href = event.currentTarget.attributes.href.value + txt
    },

    getEmailText(lang, category, product, col, selectedOptions) {
      const txts = {
        de: {
          uppertext:
            'Sehr geehrte Damen und Herren%0D%0A%0D%0A' +
            'Bitte senden Sie mir eine Offerte zum folgenden Pauschalangebot:%0D%0A',
          title: 'Produktbereich',
          subtitle: 'Produkt',
          plan: 'Pauschalangebot',
          list: 'Gewählte Module oder Add-ons:',
          subject: 'Angebotsanfrage',
        },
        fr: {
          uppertext:
            'Madame, Monsieur%0D%0A%0D%0A' +
            "Veuillez m'envoyer une offre pour le forfait suivant:%0D%0A",
          title: 'Domaine de produits',
          subtitle: 'Produit',
          plan: 'Offre groupée',
          list: 'Modules ou add-ons sélectionnés:',
          subject: 'Demande de devis',
        },
        en: {
          uppertext:
            'Dear Sir or Madam%0D%0A%0D%0A' +
            'Please send me an offer for the following package deal:%0D%0A',
          title: 'Product area',
          subtitle: 'Product',
          plan: 'Package offer',
          list: 'Selected modules or add-ons:',
          subject: 'Request for quotation',
        },
      }

      let uppertext = txts[lang].uppertext

      category = category.replace(/&/g, '+%26+')
      product = product.replace(/&/g, '+%26+')

      const title = `${txts[lang].title}:%20${category}`
      const subtitle = `${txts[lang].subtitle}:%20${product}`
      const plan = `${txts[lang].plan}:%20${col}`
      const list = selectedOptions.length > 0 ? txts[lang].list : ''

      return `?subject=${txts[lang].subject}&body=${uppertext}%0D%0A${title}%0D%0A${subtitle}%0D%0A${plan}%0D%0A${list}%0D%0A${selectedOptions}`
    },
  },
}
